import { defineMessages } from 'react-intl';

const translations = {
  from: {
    id: 'betweenOptions.from',
    defaultMessage: 'From',
    description: 'Label from between options',
  },
  to: {
    id: 'betweenOptions.to',
    defaultMessage: 'To',
    description: 'Label to between options',
  },
};

export default defineMessages(translations);
